<ion-item lines="none" [class]="'form-group-' + layout()">
  @if (labelKey()) {
    <ion-label class="form-label">
      {{ labelKey() | translate }}
      @if (isRequired()) {
        <span class="required-indicator" aria-label="required">*</span>
      }
    </ion-label>
  }
  <div class="form-field-wrapper" [style.--mbp-textarea-trailing-icon-width]="trailingIconWidth()">
    <ion-textarea
      class="form-textarea"
      [class.input-error]="errorMessage()"
      [rows]="rows()"
      [value]="internalValue()"
      [disabled]="disabled()"
      [required]="isRequired()"
      [maxlength]="maxCharacters()"
      [placeholder]="placeholderKey() | translate"
      label-placement="stacked"
      (ionInput)="handleInput($event)"
      (ionFocus)="handleFocus()"
      (ionBlur)="handleBlur()">
    </ion-textarea>
    <div class="trailing-icon">
      <ng-content select="[trailing-icon]"></ng-content>
    </div>
    <mbp-form-error [message]="errorMessage()"></mbp-form-error>
  </div>
</ion-item>
